


































































































































































































































 import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
 import Util from '../../lib/util'
 import AbpBase from '../../lib/abpbase'
 import TransferOrder from '../../store/entities/transferorder'
 import appconst from '../../lib/appconst'

 
  
 
 @Component
 export default class DetailTransferOrder extends AbpBase{


     
     @Prop({type:Boolean,default:false}) value:boolean;
     user:TransferOrder=new TransferOrder();
     pname:string="";
     cname:string="";
     vname:string="";
     transportationtime:string="";
     transfertime:string="";
     signeetime:string="";
     getdeclarestatustxt(id){
         var txt="-";
            var list =this.$store.state.transferorder.declarestatus;
          list.forEach(item=>{
                if(id==item.id){
                 txt=item.name;
                 return txt;
                }
          })
          return txt;
}
getdispatchcarstatustxt(id){
         var txt="-";
            var list =this.$store.state.transferorder.dispatchcarstatus;
          list.forEach(item=>{
                if(id==item.id){
                 txt=item.name;
                 return txt;
                }
          })
          return txt;
}
getsignstatustxt(id){
           
         var txt="-";
            var list =this.$store.state.transferorder.signstatus;
          list.forEach(item=>{
                if(id==item.id){
                 txt=item.name;
                 return txt;
                }
          })
          return txt;
}
     save(){
         

         (this.$refs.userForm as any).validate(async (valid:boolean)=>{
             
             
             if(valid){
                 await this.$store.dispatch({
                     type:'transferorder/update',
                     data:this.user
                 });
                 (this.$refs.userForm as any).resetFields();
                 this.$emit('save-success');
                 this.$emit('input',false);
             }
         })
     }
     cancel(){
         (this.$refs.userForm as any).resetFields();
         this.$emit('input',false);
     }
     visibleChange(value:boolean){
            
           
         if(!value){
             this.$emit('input',value);
           
        
         }else{
      
             this.user=Util.extend(true,{},this.$store.state.transferorder.editTransferOrder);
               
               if(this.$store.state.transferorder.editTransferOrder.productionWaste!=null){
                 this.pname=this.$store.state.transferorder.editTransferOrder.productionWaste.corporatename;
               }
               if(this.$store.state.transferorder.editTransferOrder.collectionOffice!=null){
                 this.cname=this.$store.state.transferorder.editTransferOrder.collectionOffice.corporatename;
               }
               if(this.$store.state.transferorder.editTransferOrder.transPorted!=null){
                 this.vname=this.$store.state.transferorder.editTransferOrder.transPorted.corporatename;
               }
               
              

                    if(this.user.transfertime!=null){
                          
                     this.transfertime=new Date(this.user.transfertime).toLocaleDateString();
                    }
                   if(this.user.transportationtime!=null){

                     this.transportationtime=new Date(this.user.transportationtime).toLocaleDateString();
                    }
                    
                    if(this.user.signeetime!=null){

                     this.signeetime=new Date(this.user.signeetime).toLocaleDateString();
                    }

                    
            //
         //下面小区
         //  var vcid=this.$store.state.goods.editGoods.vid;
         
             // var cid=this.area_ByVarea(vcid);
             
         }
     }
     created() {
 
     }

     userRule={
        
     }
     


     
 }  

 

 

